<template>
  <section>
    <h3 class="text-h5 text-md-h4">
      Повышайте возвращаемость и средний чек с программой лояльности
    </h3>

    <div class="mt-6 mt-md-12">
      <div
        v-for="(item, index) in loyaltyClinicFeatureItems"
        :key="index"
        class="loyalty-feature-item d-flex overflow-hidden rounded-xl
        flex-column flex-md-row pt-3 pt-md-0 px-3 px-md-0 mt-4 mt-md-6"
      >
        <div class="d-flex mr-0 mr-md-6 align-center">
          <span class="list-number-marker text-primary">{{ index + 1 }}</span>
          <div class="font-weight-semi-bold ml-6 pt-0 pt-md-3 text-landing-body-2 text-md-landing-h5">
            {{ item.title }}
          </div>
        </div>

        <LandingFeatureImage
          class="align-self-center mt-4 mt-md-0"
          height="178"
          sm-height="126"
          :src="item.src"
          :sm-src-set="item.smSrc"
          :alt="item.alt"
        />
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
const loyaltyClinicFeatureItems = computed(() => [
  {
    title: 'Подключите модуль «Программа лояльности» в МИС МедЛок',
    src: '/images/features/clinic/loyalty_program.png',
    smSrc: '/images/features/clinic/loyalty_program_mobile.png',
    alt: 'Подключение модуля в МИС МедЛок',
  },
  {
    title: 'Настройте правила начисления и списания бонусов',
    src: '/images/features/clinic/loyalty_program_settings.png',
    smSrc: '/images/features/clinic/loyalty_program_settings_mobile.png',
    alt: 'Настройки модуля программы лояльности',
  },
  {
    title: 'Выпускайте виртуальные бонусные карты. Они будут появляться у пациентов в приложении МедТочка',
    src: '/images/features/clinic/loyalty_program_cards.png',
    smSrc: '/images/features/clinic/loyalty_program_cards_mobile.png',
    alt: 'Виртуальные карты программы лояльности',
  },
  {
    title: 'Пациенты будут отдавать предпочтение вашей клинике и чаще пользоваться вашими услугами',
    src: '/images/features/clinic/loyalty_program_patient.png',
    smSrc: '/images/features/clinic/loyalty_program_patient_mobile.png',
    alt: 'Пациент',
  },
])
</script>

<style lang="scss">
@use '@/assets/vuetify/settings';
@use 'sass:map';

.loyalty-feature-item {
  @media #{map.get(settings.$display-breakpoints, 'sm-and-down')} {
    background: $t-ui-bg-secondary;
  }
}
</style>
